module.exports = __webpack_public_path__ + "img/bg.032ba5f0.png";